var Setster;
if(Setster == undefined) {
  Setster = {};
}

var Setster_template_version = 0;


if(!Setster.initialized) {
  Setster.currentWidget = null;
  Setster.mobileWindow = null;
  Setster.mobileTabStatusInterval = null;
  Setster.checkCount = 0;
  Setster.domainUrl = (window.domainUrl !== undefined) ? window.domainUrl : 'https://www.setster.com/';

  Setster.gId = function(id) {
    return document.getElementById(id);
  };

  Setster.hasClassName = function(element, className) {
    var elementClassName = element.className;

    return (elementClassName.length > 0 && (elementClassName == className ||
      new RegExp("(^|\\s)" + className + "(\\s|$)").test(elementClassName)));
  };

  Setster.addClassName = function(element, className) {
    if (!Setster.hasClassName(element, className))
      element.className += (element.className ? ' ' : '') + className;
    return element;
  };

  Setster.removeClassName = function(element, className) {
    var newClass = Setster.strip(element.className.replace(new RegExp("(^|\\s+)" + className + "(\\s+|$)"), ' '));
    element.className = newClass;
    return element;
  };

  Setster.strip = function(string) {
    return string.replace(/^\s+/, '').replace(/\s+$/, '');
  };

  Setster.add_css = function(css_content) {
    var head = document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if(style.styleSheet) {
      style.styleSheet.cssText = css_content;
    } else {
      rules = document.createTextNode(css_content);
      style.appendChild(rules);
    }
    head.appendChild(style);
  };

  Setster.gup = function(name) {
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( window.location.href );
    if( results == null )
      return "";
    else
      return results[1];
  };

  Setster.checkMobileTab = function() {
    Setster.checkCount++;
    if(Setster.currentWidget && Setster.mobileWindow && Setster.mobileWindow.closed) {
      Setster.currentWidget.onMobileTabClose();
    }
  }

  Setster.initialized = true;
}



Setster.feedback_widget = function(options) {
	setster_widget = new Setster.setster_widget(options);
	return setster_widget;
}

Setster.setster_widget = function(options) {
  this.options = options ? options : {};
  this.options.setsterURL = Setster.domainUrl + 'widget/';
  //this.is_ssl = ("https:" == document.location.protocol);
  this.is_ssl = true;
  this.openOnLoad = false;
  this.smallIframe = false;
  this.mobileUrl = '';

  if (this.options.container) {
    var wrapper = document.getElementById(this.options.container);
    if (wrapper === null) {
      wrapper = document.createElement('div');
      wrapper.id = this.options.container;
      document.body.appendChild(wrapper);
    }
  }

  if(this.options.setsterExperience){ this.options.displayMode = this.options.setsterExperience;}
  if(!this.options.displayMode) this.options.displayMode = "auto";

  if(!this.options.display) this.options.display = "overlay";

  this.baseURL = this.options.setsterURL;

  this.empty = 'about:blank';

  // iframe onload handler
  this.loadingHandler = null;

  var bookImg = '';
  this.frameSrc = this.baseURL + "?";

  if(this.options.uri)  {
  		this.frameSrc += "&uri=" + this.options.uri;
  		bookImg += "&uri=" + this.options.uri;
  }
  if(this.options.company) {
		this.frameSrc += "&compID=" + this.options.company;
		bookImg += "&compID=" + this.options.company;
  }
  if(this.options.locationsMap) {
	this.frameSrc += "&locationsMap=" + this.options.locationsMap;
  }

  if(typeof(_gaq) == "undefined" && typeof(ga) == "undefined"){
    var gaqEnabled = 1;
  }else{
    var gaqEnabled = 0;
  }

  if(this.options.version) this.frameSrc += "&vs=" + encodeURIComponent(this.options.version);
  if(this.options.t) this.frameSrc += "&t=" + encodeURIComponent(this.options.t);
  if(this.options.profilePage) this.frameSrc += "&pp=1";
  if(this.options.returnUrl) this.frameSrc += "&returnUrl=" + encodeURIComponent(this.options.returnUrl);
  if(this.options.defaultLocation) this.frameSrc += "&defaultLocation=" + encodeURIComponent(this.options.defaultLocation);
  if(this.options.defaultLocationCode) this.frameSrc += "&defaultLocationCode=" + encodeURIComponent(this.options.defaultLocationCode);
  if(this.options.defaultService) this.frameSrc += "&defaultService=" + encodeURIComponent(this.options.defaultService);
  if(this.options.defaultProvider) this.frameSrc += "&defaultProvider=" + encodeURIComponent(this.options.defaultProvider);
  if(this.options.theme) this.frameSrc += "&theme=" + encodeURIComponent(this.options.theme);
  if(this.options.showDefaultLocation) this.frameSrc += "&showDefaultLocation=" + encodeURIComponent(this.options.showDefaultLocation);
  if(this.options.newTabMobileWidget) this.frameSrc += "&newTabMobileWidget=" + encodeURIComponent(this.options.newTabMobileWidget);
  this.frameSrc += "&gaqEnabled=" + encodeURIComponent(gaqEnabled);

  if(this.options.defaultName) this.frameSrc += "&dn=" + encodeURIComponent(this.options.defaultName);
  if(this.options.defaultEmail) this.frameSrc += "&de=" + encodeURIComponent(this.options.defaultEmail);
  if(this.options.defaultNotes) this.frameSrc += "&dnt=" + encodeURIComponent(this.options.defaultNotes);
  if(this.options.defaultCustom) {
  	for(field in this.options.defaultCustom)
  		if(this.options.defaultCustom.hasOwnProperty(field))
  			this.frameSrc += "&dc"+field+"=" + encodeURIComponent(this.options.defaultCustom[field]);
  }
  if(this.options.verticalPostion) {
      Setster.vPostion = this.options.verticalPostion;
  } else{
      Setster.vPostion = 0;
  }

  var act = Setster.gup('sw_act');
  if('confirm' == act || 'reschedule' == act || 'cancel' == act) {
    var id = Setster.gup('sw_id');
    var h = Setster.gup('sw_h');

    if(id && h) {
      this.options.otherparams = "&id="+encodeURIComponent(id)+"&h="+encodeURIComponent(h)+"&act="+act;
      this.openOnLoad = true;
      this.smallIframe = act != 'reschedule';
    }
  }

  if(this.options.buttonName) {
  	bookImg += "&buttonName=" + encodeURIComponent(this.options.buttonName);
  }
  if(this.options.intern) this.frameSrc += "&intern=1";
  if(this.options.display == 'overlay') this.frameSrc += "&overwdg=1";
  if(this.options.noInfo) this.frameSrc += "&noInfo=1";
  if(this.options.otherparams) this.frameSrc += this.options.otherparams;
  this.frameSrc += '&ref=' + encodeURIComponent(document.location.href);

  this.options.placement = this.options.placement ? this.options.placement : 'left';
  bookImg += "&placement=" + this.options.placement;

  var iframeWidth = "100%";
  if(this.options.noInfo) { iframeWidth = "100%"; }

  if(this.options.display == 'overlay') {
    // onload="var vs=this.contentDocument.body.getAttribute(\'data-widgetversion\');if(vs==2) document.getElementById(\'setstr_close\').style.top = \'13px\';"
    this.iframe_html = '<iframe src="' +  this.empty + '" id="setstr_iframe" allowTransparency="true" scrolling="no" frameborder="0"></iframe>';
  } else {
    if(this.isMobile()) this.frameSrc += "&overwdg=1";
    this.iframe_html = '<iframe src="' + this.frameSrc + '" width="' + iframeWidth + '" height="471px" id="setstr_iframe" allowTransparency="true" scrolling="yes" frameborder="0"></iframe>';
  }


  if (window.addEventListener) {  // Firefox, Opera and Safari
    window.addEventListener ("message", this.onMessage, false);
  }
  else {
    if (window.attachEvent) {   // Internet Explorer
      window.attachEvent("onmessage", this.onMessage);
    }
  }


  if (window.addEventListener) {  // Firefox, Opera and Safari
    window.addEventListener("message", this.receiveGaMessage, false);
  }
  else {
    if (window.attachEvent) {   // Internet Explorer
      window.attachEvent("onmessage", this.receiveGaMessage);
    }
  }


  //add google analytics support for iframe
  if(typeof(_gaq) != "undefined")
  {
	  var _gaq = _gaq || [];
	  _gaq.push(['_setDomainName', window.location.hostname]);
	  _gaq.push(['_setAllowLinker', true]);

	  _gaq.push(function() {
		var pageTracker = _gat._getTrackerByName();
		var iframe = document.getElementById('setstr_iframe');
		iframe.src = pageTracker._getLinkerUrl(this.baseURL + '?&uri=' + this.options.uri);
	 });
  }

  this.tab_html = '<a href="#" id="setstr_tab" class="setstr_tab_'+this.options.placement+'">Book It</a>';
  if(this.options.display == 'hidden')
		this.tab_html = '';

  this.overlay_html = '<div id="setstr_overlay" style="display:none">' +
                        '<div id="setstr_container">' +
                          '<a href="#" id="setstr_close"></a>' +
								this.iframe_html +
                        '</div>' +
                        '<div id="setstr_screen"></div>' +
                      '</div>';

  if(undefined == this.options.displayMode || this.options.displayMode == 'web' || this.options.displayMode == 'desktop' || this.options.displayMode == 'auto') {
    if(this.options.display == 'overlay') {
      var iframeWidth;
      var containerWidth;
      if(this.smallIframe) {
        iframeWidth = '450px';
        containerWidth = '470px';
      }
      else {
        iframeWidth = '665px';
        containerWidth = '685px';
      }
      var raw_css = "#setstr_overlay {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1000000;\n  position: absolute; }\n\n#setstr_screen {\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  position: absolute;\n  background-color: #000;\n  opacity: 0.45;\n  -moz-opacity: 0.45;\n  filter: alpha(opacity=45); }\n\n#setstr_container {\n  width: "+containerWidth+";\n  height: 480px;\n  margin: 0 auto;\n  z-index: 2;\n  position: relative; }\n  #setstr_container iframe {\n    width: "+iframeWidth+";\n    height: 100%;\n    margin: 20px;\n    background: transparent; }\n  \na#setstr_tab {\n border:0px; background-color:transparent; top: 25%;\n  left: 0;\n  width: 43px;\n  height: 150px;\n  color: #FFF;\n  cursor: pointer;\n  text-indent: -100000px;\n  overflow: hidden;\n  position: fixed;\n  z-index: 100000;\n  margin-left: -10px;\n  background-image: url("+this.baseURL+"appointment_btn.php?" + bookImg +"); background-repeat:no-repeat; \n  _position: absolute;\n  }\n  a#setstr_tab:hover {\n    margin-left: -4px; }\n\na.setstr_tab_right {\n  right: 0 !important;\n left: auto !important;\n  margin-right: -5px !important;\n  margin-left: auto !important;\n  width: 41px !important; }\n  a.setstr_tab_right:hover {\n    width: 45px !important;\n    margin-right: 0 !important;\n    margin-left: auto !important; }\n\na.setstr_tab_bottom {\n  top: auto!important;\n  bottom: 0 !important;\n  left: 20% !important;\n  height: 50px !important;\n  width: 232px !important;\n  margin-bottom: -7px !important;\n  margin-left: auto !important; }\n  a.setstr_tab_bottom:hover {\n    margin-bottom: -4px !important;\n    margin-left: auto !important; }\n\na.setstr_tab_hidden {\n  display: none !important; }\n\na#setstr_close {\n border:0px; background-color:transparent; position: absolute;\n  cursor: pointer;\n  outline: none;\n top: 13px; left:5px;\n \n  z-index: 4;\n  width: 42px;\n  height: 42px;\n  overflow: hidden;\n  background-image: url(" + this.baseURL + "images\/close.png);\n  _background: none;\n  _filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='"+ this.baseURL +"images\/close.png', sizingMethod='crop'); }\n  a#setstr_close:hover {\n    background-position: -42px 0; }\n\n.setster_tab_on embed, .setster_tab_on select, .setster_tab_on object {\n  visibility: hidden; } .setster_miniwidget .input { background:url(\"" + this.domainUrl + "widget/images/field_bk.gif\") repeat-x left top #FFFFFF;border:1px solid #B4B4B4;padding:4px 3px 3px;border-top:0px;border-bottom:1px solid #dadada;}\n";

      Setster.add_css(raw_css);

        if(this.options.container) {
          var container_el = Setster.gId(this.options.container);
          if (container_el !== null) {
            container_el.innerHTML = this.tab_html + this.overlay_html;
          } else {
            document.write(this.tab_html);
            document.write(this.overlay_html);
          }
        } else {
          document.write(this.tab_html);
          document.write(this.overlay_html);
        }

      if(this.options.uri)  {
          checkTemplateVersion(this.options.uri);
      }

      var setster_obj = this;

        Setster.gId('setstr_tab').onclick = function() { setster_obj.show(); return false; }
        Setster.gId('setstr_close').onclick = function() {
          if(setster_obj.options.returnUrl)
            window.location = setster_obj.options.returnUrl;
          else
            setster_obj.hide();
          return false;
        }

      var fisrtIframeSrc = this.empty;
      if(!this.options.intern && this.options.display == 'overlay') {
      	fisrtIframeSrc = this.baseURL + 'count_button_views.php?';
      	if(this.options.uri) fisrtIframeSrc = fisrtIframeSrc + "&uri=" + this.options.uri;
    		if(this.options.company) fisrtIframeSrc = fisrtIframeSrc + "&compID=" + this.options.company;
    		fisrtIframeSrc = fisrtIframeSrc + '&ref=' + encodeURIComponent(document.location.href);
      }

      if (!navigator.userAgent.match(/Trident/i)) {
        var _self = this;
        this.isMobileEnabled().then(function (isMobileEnabled) {
          if (!_self.isMobile() || !isMobileEnabled) {
            if (fisrtIframeSrc !== 'about:blank') {
              fetch(fisrtIframeSrc);
            }
          }
        });
      } else {
        if (!this.isMobile()) {
          Setster.gId('setstr_iframe').setAttribute("src", fisrtIframeSrc);
        }
      }

      window.onresize = this.set_position;

      if(/MSIE 6/i.test(navigator.userAgent) || /MSIE 7/i.test(navigator.userAgent))
        window.onscroll = function() {
          setster_obj.update_tab_position();
        }

      if(this.openOnLoad && !Setster.currentWidget)
        this.show();
    } else {
      if (!navigator.userAgent.match(/Trident/i)) {
        var _self = this;
        this.isMobileEnabled().then(function (isMobileEnabled) {
          if (_self.isMobile() && isMobileEnabled) {
            _self.show();
          } else {
            if (_self.options.container) {
              var container_el = Setster.gId(_self.options.container);
              container_el.innerHTML = _self.iframe_html;
            } else {
              document.write(_self.iframe_html);
            }
          }
        });
      } else {
        if (this.isMobile()) {
          this.show();
        } else {
          if (this.options.container) {
            var container_el = Setster.gId(this.options.container);
            container_el.innerHTML = this.iframe_html;
          } else {
            document.write(this.iframe_html);
          }
        }
      }
    }
  }
  else {
    this.mobileUrl = this.frameSrc + '&displayMode=mobile';
    if(this.openOnLoad && !Setster.currentWidget)
      this.show();
  }
};

Setster.setster_widget.prototype = {
  baseURL: '',

  miniwidgetSubmit:	function(form) {
  	var zCode = form.elements["st_location_zip"].value;
  	if(zCode == "Enter Zip Code") {
  		alert("Enter the zip code");
  		form.elements["st_location_zip"].focus();
  		return false;
  	}
    this.show("&location_zip=" + encodeURIComponent(zCode));
    return false;
  },

  asset_url: function(asset) {
    return this.asset_base_url + asset;
  },


  set_position : function() {
    this.scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
    this.scroll_height = document.documentElement.scrollHeight;
    this.client_height = window.innerHeight || document.documentElement.clientHeight;

    Setster.gId('setstr_screen').style.height = this.scroll_height+"px";
    Setster.gId('setstr_container').style.top = this.scroll_top+(this.client_height*0.1)+"px";
    if(Setster.vPostion){
        Setster.gId('setstr_container').style.top  = Setster.vPostion + "px";
    }
  },

  update_tab_position : function() {
    this.scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
    Setster.gId('setstr_tab').style.top = this.scroll_top+140+"px";
  },
  isMobile: function() {
//     if( navigator.userAgent.match(/Android/i)
//       || navigator.userAgent.match(/webOS/i)
//       || navigator.userAgent.match(/iPhone/i)
//       || navigator.userAgent.match(/iPad/i)
//       || navigator.userAgent.match(/iPod/i)
//       || navigator.userAgent.match(/BlackBerry/i)
//       || navigator.userAgent.match(/Windows Phone/i)
//     ){
//       return true;
//     }
//     else {
      return false;
//     }
  },
  isMobileEnabled: function() {
    if (!navigator.userAgent.match(/Trident/i)) {
      var url = Setster.domainUrl + '/widget/index.php?get_enable_mobile_widget=1&callback_enable_mobile_widget=1&uri=' + this.options.uri;
      var deferred = new Promise(function (resolve, reject) {
        fetch(url)
        .then(function (response) {
          response.text().then(function(body) {
            var parsedBody = body.replace('Setster_callback_enable_mobile_widget(', '');
            parsedBody = parsedBody.replace(')', '');
            resolve(parseInt(parsedBody));
          });
        })
        .catch(function (err) {
          reject(err);
        });
      });

      return deferred;
    }
  },
  isMobileRequired:function(){
     var returnVal = Setster_jsonp_enable_mobile_widget(Setster.domainUrl + '/widget/index.php?get_enable_mobile_widget=1&callback_enable_mobile_widget=1&uri='+this.options.uri);
     returnVal = parseInt(returnVal);
     return returnVal;
  },
  changeLocation: function(loc){
	 window.location = loc;
  },
  openWindow: function(loc){
    var form = document.createElement("form");
    form.setAttribute("action",loc);
    form.setAttribute("method","GET");
    form.setAttribute("target","_blank");
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  },
  show : function(params) {
    if (!navigator.userAgent.match(/Trident/i)) {
      var _self = this;
      this.isMobileEnabled().then(function (isMobileEnabled) {
        if ((_self.isMobile() && isMobileEnabled) && _self.options.uri != 'brilliantearth' && _self.options.uri != 'caratlondon') {
          var mobileUrl = _self.frameSrc;
          mobileUrl = mobileUrl.replace("widget", "mobile");
          mobileUrl = mobileUrl.replace("?&uri", "?&nickname");
          window.open(mobileUrl, '_blank');
          return;
        }
      });
    } else {
      if (this.isMobile() && this.options.uri != 'brilliantearth' && _self.options.uri != 'caratlondon') {
        var mobileUrl = this.frameSrc;
        mobileUrl = mobileUrl.replace("widget", "mobile");
        mobileUrl = mobileUrl.replace("?&uri", "?&nickname");
        window.open(mobileUrl, '_blank');
        return;
      }
    }

      if(typeof(_gaq) == "undefined" && typeof(ga) == "undefined"){
        var gaqEnabled = 1;
      }else{
        var gaqEnabled = 0;
      }
      this.frameSrc += "&gaqEnabled=" + encodeURIComponent(gaqEnabled);

    Setster.currentWidget = this;
    if(typeof(_gaq) != "undefined"){
        _gaq.push(['_setDomainName', window.location.hostname]);
        _gaq.push(['_setAllowLinker', true]);
        _gaq.push(['_setAllowHash', false]);
            if(this.isMobile()){
            if(this.isMobileRequired()){
                var mobileUrl = this.frameSrc;
                mobileUrl = mobileUrl.replace("widget", "mobile");
                mobileUrl = mobileUrl.replace("?&uri", "?&nickname");
                _gaq.push(['_link', mobileUrl]);
                return;
            }
            }
    }

    if(typeof(ga) != "undefined"){
        ga('require', 'linker');
        ga('linker:autoLink', ['setster.com'], true );
        //var gaCID = ga.getAll()[0].get('clientId');
            if(this.isMobile() && this.options.uri == 'tdolhescu'){
                var mobileUrl = this.frameSrc;
                mobileUrl = mobileUrl.replace("widget", "mobile");
                mobileUrl = mobileUrl.replace("?&uri", "?&nickname");
                ga(function(tracker) {
                  var linker = new window.gaplugins.Linker(tracker);
                  mobileUrl = linker.decorate(mobileUrl);
                });
                window.open(mobileUrl, '_blank');
                return;
            }
    }

    if(typeof(ga) != "undefined"){
        ga('require', 'linker');
        ga('linker:autoLink', ['setster.com'], true );
        //var gaCID = ga.getAll()[0].get('clientId');
            if(this.isMobile() && this.options.uri == 'Indochino'){
                var mobileUrl = this.frameSrc;
                mobileUrl = mobileUrl.replace("widget", "mobile");
                mobileUrl = mobileUrl.replace("?&uri", "?&nickname");
                ga(function(tracker) {
                  var linker = new window.gaplugins.Linker(tracker);
                  mobileUrl = linker.decorate(mobileUrl);
                });
                window.open(mobileUrl, '_blank');
                return;
            }
    }

    if(this.options.displayMode == 'mobile') {
      //window.location = this.mobileUrl;
      Setster.mobileWindow = window.open(this.mobileUrl, '_blank');
      Setster.mobileTabStatusInterval = setInterval(Setster.checkMobileTab, 500);
      return;
    }
    if(typeof(params) == "undefined") params = "";
    Setster.gId('setstr_iframe').setAttribute("src", this.frameSrc + params);

    this.loadingHandler = (function(that){
  		// 'that' is used to access the setster widget object in Setster::loaded() by sending it as a parameter to that call
  		// also, we define the handler here like this and not as an anonymous function so that we can
  		// remove it as the event handler when we hide the widget
  		var handler = function(){that.loaded(that)};

  		if (Setster.gId('setstr_iframe').addEventListener) {
  			Setster.gId('setstr_iframe').addEventListener("load", handler, false);
  		} else if (Setster.gId('setstr_iframe').attachEvent) {
  			Setster.gId('setstr_iframe').attachEvent("onload", handler);
  		}

  		return handler;
  	})(this);

    this.set_position();

    Setster.addClassName(document.getElementsByTagName('html')[0], 'setster_tab_on');
    Setster.gId('setstr_overlay').style.display = "block";
  },

  hide : function() {
    if (Setster.gId('setstr_iframe').addEventListener) {
      Setster.gId('setstr_iframe').removeEventListener("load", this.loadingHandler, false);
    } else if (Setster.gId('setstr_iframe').attachEvent) {
      Setster.gId('setstr_iframe').detachEvent("onload", this.loadingHandler);
    }

    Setster.gId('setstr_overlay').style.display = "none";
    Setster.gId('setstr_iframe').setAttribute("src", this.empty);
    Setster.gId('setstr_iframe').className = "loading";

    Setster.removeClassName(document.getElementsByTagName('html')[0], 'setster_tab_on');
    Setster.currentWidget = null;
  },
  onMobileTabClose: function() {
    if(Setster.mobileTabStatusInterval)
      clearInterval(Setster.mobileTabStatusInterval);

    Setster.mobileTabStatusInterval = null;
    Setster.mobileWindow = null;
    Setster.currentWidget = null;

    if(this.options && this.options.returnUrl) {
      var that = this;
      (function(){
        var r = that.options.returnUrl;
        setTimeout(function(){
          try {
            window.focus();
          }catch(e){}
          window.location = r;
        },100);
      })();
    }
  },
  loaded : function(that) {
    that.set_position();

    try{
      if(Setster.gId('setstr_iframe').contentWindow.document) {
        var vs=Setster.gId('setstr_iframe').contentWindow.document.body.getAttribute('data-widgetversion');
        var btn=Setster.gId('setstr_close');
        //if(vs!=2) btn.style.left = '0px';
      }
    }catch(e){
    }

    Setster.gId('setstr_iframe').className = "loaded";
  },

  onMessage:function(e) {
    if(typeof(e.data.type) != "undefined"){return;}
    var o = e.origin.slice(-12);
    var pattern = /([setster|boxago].[com|gzg]+)\/?$/;
    if (o.search(pattern) !== -1) {
        var msg;
        eval("msg = " + e.data+";");
        if(msg.act == "showmobilewidget") {
          (function(){
            var wdg = Setster.currentWidget;
            Setster.currentWidget.hide();
            wdg.options.displayMode = 'mobile';
            wdg.mobileUrl = wdg.frameSrc + '&displayMode=mobile';

            setTimeout(function(){wdg.show();}, 500);
          })();
        }
        if(msg.act == "closewidget") {
          if(Setster.currentWidget == null){
              window.location.reload();
          }else{
            Setster.currentWidget.hide();
          }
        }
        if(msg.act == "closemobilewindow") {
          if(Setster.mobileWindow) {
            Setster.mobileWindow.close();
            if(Setster.currentWidget)
              Setster.currentWidget.onMobileTabClose();
          }
        }
        if(msg.act == "redirect") {
          window.location = msg.url;
        }
    }
  },
  receiveGaMessage:function(event){
    if (
      event.origin == "https://www.setster.com" ||
      event.origin == "https://setster.gzg" ||
      event.origin == "https://www.boxago.com"
    ) {
      if (event.data && event.data.action == "Setster Appointment") {
        if (typeof _gaq != "undefined") {
          _gaq.push([
            "_trackEvent",
            event.data.action,
            event.data.label,
            event.data.value
          ]);
        } else if (typeof ga != "undefined") {
          //ga('send', 'event', event.data.action, event.data.label, event.data.value);
          ga("send", "event", {
            eventCategory: event.data.action,
            eventAction: event.data.label,
            eventLabel: event.data.value,
            hitCallback: function() {
              StoreGaResult(event.data.value);
            }
          });
        }
      }
    }
  },
  widget_url: function() {
    var widgetUrl = this.frameSrc;
    if (this.isMobile()) {
        widgetUrl = widgetUrl.replace("widget", "mobile");
        widgetUrl = widgetUrl.replace("?&uri", "?&nickname");
    }
    return widgetUrl;
  }
}
function Setster_jsonp_enable_mobile_widget(url){
    var script = document.createElement("script");
    script.setAttribute("src",url);
    document.body.appendChild(script);
    return Setster_enable_mobile_widget;
}
function Setster_callback_enable_mobile_widget(val){
    Setster_enable_mobile_widget = val;
}
var Setster_enable_mobile_widget = null;

function StoreGaResult(appId){
     appId = parseInt(appId.split(' - ')[1]);
     var url = setsHost+'apptgamonitor.php?success_app_id='+appId;
     var script = document.createElement("script");
     script.setAttribute("src",url);
     document.body.appendChild(script);
}

function checkTemplateVersion(nickname){
     var url = Setster.domainUrl + 'widget/index.php?get_template_widget=1&uri='+nickname;
     var script = document.createElement("script");
     script.setAttribute("src",url);
     document.body.appendChild(script);
}

function Setster_template_version_callback(val){
    if(val == 1){
        Setster.add_css("a#setstr_close{left:auto;right:17px;width:29px;height:29px;top:43px;background-image:url(" + Setster.domainUrl + "widget/images/v2/close_btn_widget.png);background-size: contain;}\n"+
        "a#setstr_close:hover{background-position: 0 0;}\n");
    }
}

